import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  OrganizationSubscriptionResponse,
  PaymentHistoryResponse,
  PlanUsageResponse,
  SubscribeRequest,
  SubscriptionCheckoutResponse,
  SubscriptionPlanResponse,
} from '@/types/subscription';

export const subscriptionsApi = {
  listPlans: () =>
    unwrap(api.get<ApiResponse<SubscriptionPlanResponse[]>>('/v1/subscriptions/plans')),

  current: () =>
    unwrap(api.get<ApiResponse<OrganizationSubscriptionResponse | null>>('/v1/subscriptions/current')),

  usage: () => unwrap(api.get<ApiResponse<PlanUsageResponse>>('/v1/subscriptions/usage')),

  checkout: (body: SubscribeRequest) =>
    unwrap(api.post<ApiResponse<SubscriptionCheckoutResponse>>('/v1/subscriptions/checkout', body)),

  subscribe: (body: SubscribeRequest) =>
    unwrap(api.post<ApiResponse<OrganizationSubscriptionResponse>>('/v1/subscriptions/subscribe', body)),

  paymentHistory: () =>
    unwrap(api.get<ApiResponse<PaymentHistoryResponse[]>>('/v1/subscriptions/payments')),

  setAutoRenew: (enabled: boolean) =>
    unwrap(
      api.patch<ApiResponse<null>>('/v1/subscriptions/auto-renew', null, { params: { enabled } }),
    ),

  submitCustomPlanRequest: (body: CustomPlanRequestDto) =>
    unwrap(
      api.post<ApiResponse<CustomPlanRequestResponse>>('/v1/subscriptions/custom-plan-request', body),
    ),

  listCustomPlanRequests: () =>
    unwrap(api.get<ApiResponse<CustomPlanRequestResponse[]>>('/v1/subscriptions/custom-plan-request')),
};

export interface CustomPlanRequestDto {
  contactEmail?: string;
  contactPhone?: string;
  message?: string;
  requestedStores?: number;
  requestedEmployees?: number;
  requestedProducts?: number;
}

export interface CustomPlanRequestResponse {
  id: number;
  organizationId: number;
  organizationName?: string;
  contactEmail?: string;
  contactPhone?: string;
  status: string;
  planId?: number;
  message?: string;
  requestedStores?: number;
  requestedEmployees?: number;
  requestedProducts?: number;
  createdAt?: string;
}
